import N from "./useContract.js";
import { useMemo as O, useCallback as e } from "react";
import { erc721Abi as p } from "viem";
const A = (a, r) => {
  const m = O(() => ({
    abi: {
      POLYGON: p,
      RONIN: p
    },
    address: {
      POLYGON: r,
      RONIN: r
    },
    method: "isApprovedForAll"
  }), [r]), v = O(() => ({
    abi: {
      POLYGON: p,
      RONIN: p
    },
    address: {
      POLYGON: r,
      RONIN: r
    },
    method: "setApprovalForAll"
  }), [r]), {
    call: c
  } = N(m), {
    send: t
  } = N(v);
  return e(async (i, o) => (o == null || o(), await c(a, i) || await t(i, !0), !0), [c, t, a]);
};
export {
  A as default
};
//# sourceMappingURL=useApproveErc721.js.map
